import { ContactFieldRequestModel } from "./contact-field-request.model";

export interface ContactFieldsRequestModel {
  contactFieldRequests: ContactFieldRequestModel[];
}
